import {useLocalStorage} from '@rehooks/local-storage';
import {LocalStorageKeys} from '../common/types';

export const useIsRieltorApp = () => {
  const [isRieltorApp] = useLocalStorage(LocalStorageKeys.IsRieltorApp);

  return !!isRieltorApp;
};

export const useIsAndroidRieltorApp = () => {
  //useragent with app_rieltor_dashboard

  return /app_rieltor_dashboard/.test(navigator.userAgent);
}
